// eslint-disable-next-line max-classes-per-file
import $ from 'jquery';
import { Swiper, Navigation } from 'swiper';
import { Fancybox } from '@fancyapps/ui';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

class GalleryJS {
  constructor() {
    this.prevBtn = document.querySelector('.gallery__nav--prev');
    this.nextBtn = document.querySelector('.gallery__nav--next');
    this.gallerySlider = null;
    this.sliderWrapper = $('.gallery .swiper-wrapper');
    this.slidesHolder = [];
    this.images = $('.gallery__item');
    this.slidesHolder = [];
  }

  fillHolders = () => {
    for (let i = 0; i < this.images.length; i++) {
      const newSlide = document.createElement('div');
      const id = `slide-${Date.now()}-${i}`;
      const image = this.images[i].cloneNode(true);
      newSlide.classList.add('swiper-slide');
      newSlide.setAttribute('id', id);
      newSlide.append(image);

      this.slidesHolder.push(newSlide);
    }
  };

  init = () => {
    // eslint-disable-next-line no-undef
    if ($(window).width() < breakpoints.desktop) {
      if (!this.gallerySlider) {
        this.fillHolders();
        this.initSlider();
      }
    } else if (this.gallerySlider) {
      this.destroySlider();
    }
  };

  initSlider = () => {
    this.gallerySlider = new Swiper('.gallery__swiper-container', {
      modules: [Navigation, HideOffscreenSlides],
      speed: 700,
      slidesPerView: 1,
      spaceBetween: 24,
      preloadImages: true,
      autoHeight: true,
      init: false,
      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
      },
    });

    this.gallerySlider.on('slideChange', () => {
      if (this.gallerySlider.realIndex >= 1) {
        this.prevBtn.classList.add('active');
      } else {
        this.prevBtn.classList.remove('active');
      }
    });

    this.slidesHolder.forEach((el) => {
      this.sliderWrapper.append(el);
    });

    this.gallerySlider.init();
  };

  destroySlider = () => {
    if (this.sliderWrapper.find('.swiper-slide')) {
      this.sliderWrapper.find('.swiper-slide').remove();
    }
    if (this.gallerySlider) {
      this.gallerySlider.destroy();
      this.gallerySlider = null;
    }
  };
}

const Gallery = new GalleryJS();

Gallery.init();

Fancybox.bind('[data-fancybox]', {});

window.addEventListener('resize', () => {
  Gallery.init();
});
